"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedConnectionStatus = exports.ConnectionCategory = exports.AccountStatus = void 0;
/**
 * The status of an account
 * - PENDING: The connection is pending
 * - PROCESSING: The connection is being processed
 * - ERROR_NO_ACCOUNT_SETUP: The connection has an error because the account is not setup
 * - ERROR_PERMISSIONS: The connection has an error because the permissions are not setup
 * - REAUTH: The connection needs to be reauthorized
 * - CONNECTED: The connection is connected
 * - DISCONNECTED: The connection is disconnected
 * - UNKNOWN: The connection status is unknown
 */
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["PENDING"] = "PENDING";
    AccountStatus["PROCESSING"] = "PROCESSING";
    AccountStatus["ERROR_NO_ACCOUNT_SETUP"] = "ERROR_NO_ACCOUNT_SETUP";
    AccountStatus["ERROR_PERMISSIONS"] = "ERROR_PERMISSIONS";
    AccountStatus["REAUTH"] = "REAUTH";
    AccountStatus["CONNECTED"] = "CONNECTED";
    AccountStatus["DISCONNECTED"] = "DISCONNECTED";
    AccountStatus["UNKNOWN"] = "UNKNOWN";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var ConnectionCategory;
(function (ConnectionCategory) {
    /** Manual connections. (e.g. ImplementationKind.ASSISTED) */
    ConnectionCategory["Assisted"] = "assisted";
    /** Automated connections. (e.g. ImplementationKind.CREDENTIAL, ImplementationKind.API_TOKEN, ImplementationKind.OAUTH) */
    ConnectionCategory["Automated"] = "automated";
})(ConnectionCategory || (exports.ConnectionCategory = ConnectionCategory = {}));
/**
 * The aggregated status across all accounts for a connection (employer)
 * - PENDING: All accounts are pending
 * - NEEDS_ATTENTION: At least one account needs attention due to it being in pending state or having an error
 * - CONNECTED: All accounts are connected
 * - DISCONNECTED: All accounts are disconnected
 * - REAUTHORIZATION_NEEDED: Account needs reauthorization
 * - NO_ACCOUNT_SET_UP: No account has been set up
 * - INSUFFICIENT_PERMISSIONS: Account has insufficient permissions
 */
var AggregatedConnectionStatus;
(function (AggregatedConnectionStatus) {
    AggregatedConnectionStatus["PENDING"] = "PENDING";
    AggregatedConnectionStatus["NEEDS_ATTENTION"] = "NEEDS_ATTENTION";
    AggregatedConnectionStatus["CONNECTED"] = "CONNECTED";
    AggregatedConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
    AggregatedConnectionStatus["REAUTHORIZATION_NEEDED"] = "REAUTHORIZATION_NEEDED";
    AggregatedConnectionStatus["NO_ACCOUNT_SET_UP"] = "NO_ACCOUNT_SET_UP";
    AggregatedConnectionStatus["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
})(AggregatedConnectionStatus || (exports.AggregatedConnectionStatus = AggregatedConnectionStatus = {}));
